var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXIcon = function SvgXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.75 36c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18Zm8.985-27-6.92 8.045L28.341 28h-5.537l-5.068-7.377L11.39 28H9.75l7.258-8.437L9.75 9h5.536l4.8 6.986L26.096 9h1.64Zm-9.902 9.605.735 1.052 5.01 7.164h2.518l-6.138-8.78-.735-1.052-4.723-6.754h-2.519l5.851 8.37Z",
    clipRule: "evenodd"
  })));
};
export default SvgXIcon;